import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SetLoading, UpdateVariants } from 'src/redux/actions/Variants';
import { useEntityIdQueryParam, useVariantList } from './useAbTest';
import { v4 as uuidv4 } from 'uuid';

type Props = {
  children: React.ReactNode
}

const KEY = 'ajs_anonymous_id'

export const loadEntityIdFromStorage = (): string => {
  try {
    const guid = localStorage.getItem(KEY) || '""'

    return JSON.parse(guid) || ''
  } catch (e) {
    return ''
  }
}

export const saveEntityIdToStorage = (entityId: string): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(entityId))
  } catch (e) {
  }
}

function AbTestProvider({ children }: Props) {
  const dispatch = useDispatch()
  const { getVariantList } = useVariantList()
  const entityIdQueryParam = useEntityIdQueryParam()

  useEffect(() => {
    const entityId = entityIdQueryParam || loadEntityIdFromStorage() || uuidv4()

    saveEntityIdToStorage(entityId)

    dispatch(SetLoading(true))

    getVariantList(entityId)
      .then(({ getVariantList }) => {
        dispatch(UpdateVariants(getVariantList.results))
      })
  }, [getVariantList, dispatch, entityIdQueryParam]);

  return (
    <>{children}</>
  );
}

export default AbTestProvider;
